import { apiRequest } from '@/utils/request'

export function getMenuGroupList(queryParams) {
  return apiRequest({
    url: '/wechatMenuGroup/getList',
    method: 'get',
    params: queryParams
  })
}

export function getMenuList(queryParams) {
  return apiRequest({
    url: '/wechatMenu/getList',
    method: 'get',
    params: queryParams
  })
}
